/*
  Subscription Widget

  Owns form state and pricing for the subscribe / one-time selector.
  The expand/collapse animation and all selected styling are pure CSS (:has()),
  so this component only deals with:
    - enabling/disabling the hidden `selling_plan` input and setting its value
    - keeping the header price, compare price and ATC button prices in sync
    - selecting "Subscribe" when the customer picks a delivery frequency
*/

if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      connectedCallback() {
        this._subInput = this.querySelector('input[value="subscribe"]')
        this._onetimeInput = this.querySelector('input[value="onetime"]')
        this._frequencyInputs = Array.from(this.querySelectorAll('[data-plan-id]'))
        this._planField = this.querySelector('[data-selling-plan-input]')
        this._submitPrice = this.querySelector('[data-submit-price]')
        this._submitCompare = this.querySelector('[data-submit-compare]')
        this._submitCompareValue = this.querySelector('[data-submit-compare-value]')
        this._headerPrice = this.querySelector('[data-header-price]')
        this._comparePrice = this.querySelector('[data-compare-price]')
        this._regularPrice = this.dataset.regularPrice

        this._onChoiceChange = this._applyState.bind(this)
        this._onFrequencyChange = this._handleFrequencyChange.bind(this)

        this._subInput?.addEventListener('change', this._onChoiceChange)
        this._onetimeInput?.addEventListener('change', this._onChoiceChange)
        this._frequencyInputs.forEach((input) => input.addEventListener('change', this._onFrequencyChange))

        this._applyState()
      }

      /* Picking a frequency implies the customer wants to subscribe. */
      _handleFrequencyChange() {
        if (this._subInput && !this._subInput.checked) {
          this._subInput.checked = true
        }
        this._applyState()
      }

      _selectedFrequency() {
        return this._frequencyInputs.find((input) => input.checked) || this._frequencyInputs[0]
      }

      _applyState() {
        const isSubscribe = Boolean(this._subInput?.checked)
        const frequency = this._selectedFrequency()

        if (frequency) {
          if (this._headerPrice) this._headerPrice.textContent = frequency.dataset.planPrice
          if (this._comparePrice) this._comparePrice.textContent = frequency.dataset.planCompare
        }

        if (isSubscribe && frequency && this._planField) {
          this._planField.disabled = false
          this._planField.value = frequency.dataset.planId
        } else if (this._planField) {
          this._planField.disabled = true
        }

        if (this._submitPrice) {
          this._submitPrice.textContent =
            isSubscribe && frequency ? frequency.dataset.planPrice : this._regularPrice
        }

        /* Struck one-time price next to the subscription price — subscribe only */
        if (this._submitCompare) {
          const showCompare =
            isSubscribe &&
            frequency &&
            frequency.dataset.planCompare &&
            frequency.dataset.planCompare !== frequency.dataset.planPrice
          if (showCompare && this._submitCompareValue) {
            this._submitCompareValue.textContent = frequency.dataset.planCompare
          }
          this._submitCompare.classList.toggle('hidden', !showCompare)
        }
      }

      disconnectedCallback() {
        this._subInput?.removeEventListener('change', this._onChoiceChange)
        this._onetimeInput?.removeEventListener('change', this._onChoiceChange)
        this._frequencyInputs?.forEach((input) => input.removeEventListener('change', this._onFrequencyChange))
      }
    }
  )
}
